export default "__VITE_ASSET__pQiKIu3p__"